var reports = "https://shopfront-cdn.tekoapis.com/static/9ac20b6cb17519be.svg";

export { reports as default };
